import styled from 'styled-components'
import { FEATURE_BANNER_COLOR, SOLD_BANNER_COLOR, LIKE_BTN_COLOR } from '@CSSVars/colors'

export const _Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 24px;
  line-height: 24px;
  padding: ${({ featured }) => (featured ? '0 12px 0 4px' : '0 15px')};

  background-color: ${SOLD_BANNER_COLOR} !important;
  background-color: ${({ featured }) =>
    (featured ? FEATURE_BANNER_COLOR : `${SOLD_BANNER_COLOR}`)} !important;
  color: white;
  font-size: 12px;
  z-index: 100;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0,0,0);

  position: absolute;
  left: 0;
  top: 10px;

  ${({ listViewStyle }) => (listViewStyle && `
    top: 0;
    white-space: nowrap;
    width: calc(100% - 12px);
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 0 0 6px;
  `)};

  svg {
    padding: 2px;
    border-radius: 2px;
    line-height: 24px;
    background-color: ${LIKE_BTN_COLOR};
    fill: white;
  }
`

